import {Component, input} from '@angular/core';
import {UiCardComponent}  from '../../ui/ui-card/ui-card.component';
import {UiVideoBgComponent} from '../../ui/ui-video-bg/ui-video-bg.component';

export interface DialogWrapperContentIntf {
	title: string;
	descr: string[];
}

@Component({
			   selector   : 'app-dialog-wrapper',
			   imports: [
				   UiCardComponent,
				   UiVideoBgComponent
			   ],
			   templateUrl: './dialog-wrapper.component.html',
			   styleUrl   : './dialog-wrapper.component.css'
		   })
export class DialogWrapperComponent {
	content = input<DialogWrapperContentIntf>();
}
